var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { Alert, Button, ButtonContainer, Spacer } from '@emburse/ui-core';
import { setupIntentRequiresMicrodeposits } from '@ReactHooks/useStripeSubscriptionAndCheckout';
const CheckoutForm = ({ showSubscribe, onUpdatePaymentMethod, onShowMicrodepositForm, onCancel }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [errorMessage, setErrorMessage] = React.useState('');
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (elements === null) {
            return;
        }
        // Trigger form validation and wallet collection
        const { error: submitError } = yield elements.submit();
        if (submitError) {
            // Show error to your customer
            setErrorMessage(submitError.message);
            return;
        }
        const res = yield (stripe === null || stripe === void 0 ? void 0 : stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: window.location.href
            },
            redirect: 'if_required'
        }));
        if (res) {
            if (res === null || res === void 0 ? void 0 : res.setupIntent) {
                if (onShowMicrodepositForm && setupIntentRequiresMicrodeposits(res === null || res === void 0 ? void 0 : res.setupIntent)) {
                    onShowMicrodepositForm(res === null || res === void 0 ? void 0 : res.setupIntent);
                }
                else {
                    yield onUpdatePaymentMethod(res.setupIntent.payment_method);
                }
            }
            else {
                setErrorMessage(res.error.message || '');
            }
        }
    });
    const buttons = showSubscribe ? (_jsx(Button, Object.assign({ type: "submit", disabled: !stripe || !elements, style: { width: '100%' }, className: "stripe-subscribe" }, { children: "Subscribe" }))) : (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onClick: onCancel, variant: "outlined", className: "stripe-cancel" }, { children: "Cancel" })), _jsx(Button, Object.assign({ type: "submit", disabled: !stripe || !elements, className: "stripe-pay" }, { children: "Pay" }))] }));
    return (_jsxs("form", Object.assign({ onSubmit: handleSubmit }, { children: [errorMessage && (_jsxs("div", { children: [_jsx(Alert, Object.assign({ severity: "error", className: "alert-msg" }, { children: errorMessage })), _jsx(Spacer, { size: 10 })] })), _jsx(PaymentElement, {}), _jsx(Spacer, { size: 10 }), _jsx(ButtonContainer, Object.assign({ alignButtons: "right" }, { children: buttons }))] })));
};
export const StripeCheckout = (_a) => {
    var { subscription, checkoutSession } = _a, checkoutFormProps = __rest(_a, ["subscription", "checkoutSession"]);
    const stripePromise = window.Stripe(window.stripeConfig.publicKey);
    const options = {
        supportedCountries: ['US'],
        subscription: subscription,
        currency: 'usd',
        client_reference_id: subscription.id,
        clientSecret: checkoutSession.client_secret,
        // Fully customizable with appearance API.
        appearance: {
        /*...*/
        }
    };
    return (_jsx(Elements, Object.assign({ stripe: stripePromise, options: options }, { children: _jsx(CheckoutForm, Object.assign({}, checkoutFormProps)) })));
};
